module.exports = __webpack_public_path__ + "img/1.048fe279.jpeg";